import { render, staticRenderFns } from "./materialModal.vue?vue&type=template&id=769d90fd&"
import script from "./materialModal.vue?vue&type=script&lang=js&"
export * from "./materialModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports